import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { SnapshotMonitor } from 'types';

export const clearMonitors = ({ snapshotId }: { snapshotId: number }) => {
  return axios.delete(`/api/snapshots/${snapshotId}/monitors/clear`);
};

type UseClearMonitorsOptions = {
  snapshotId: number;
  config?: MutationConfig<typeof clearMonitors>;
};

export const useClearMonitors = ({
  config,
  snapshotId,
}: UseClearMonitorsOptions) => {
  return useMutation({
    onMutate: async () => {
      await queryClient.cancelQueries(['snapshot', snapshotId, 'monitors']);

      const previousMonitors = queryClient.getQueryData<SnapshotMonitor[]>([
        'snapshot',
        snapshotId,
        'monitors',
      ]);

      queryClient.setQueryData(['snapshot', snapshotId, 'monitors'], []);

      return { previousMonitors };
    },
    onError: (_, __, context: any) => {
      if (context?.previousMonitors) {
        queryClient.setQueryData(
          ['snapshot', snapshotId, 'monitors'],
          context.previousMonitors
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['snapshot', snapshotId]);
    },
    ...config,
    mutationFn: clearMonitors,
  });
};
